import { render, staticRenderFns } from "./RegionSchoolModal.vue?vue&type=template&id=2e7e3cd6&scoped=true&"
import script from "./RegionSchoolModal.vue?vue&type=script&lang=js&"
export * from "./RegionSchoolModal.vue?vue&type=script&lang=js&"
import style0 from "./RegionSchoolModal.vue?vue&type=style&index=0&id=2e7e3cd6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7e3cd6",
  null
  
)

export default component.exports